import React, { Fragment } from 'react'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'

import { Button, FormButtons, Notification } from '@portal/kit/pkg/components'
import { SubscriptionConfirmation } from '@portal/kit/pkg/widgets'

import ConfirmationContent from 'components/ran/ran-activate/confirmation-content'
import styles from './payment-succes-style'

const OfferConfirmation = ({ offer, products, theme, t }) => {
  const { order, subscription, products: productsItems  } = products

  const room = productsItems.find((e) => e.product_type === 'RanRightsProductDefinition')
  const classes = styles(theme)

  return (
    <Fragment>
      <Notification type="success" message={t('portal.offers.purchase_confirmation_text')}/>
      {/* <Confirmation title={t('portal.offers.purchase_confirmation_title')} text={t('portal.offers.purchase_confirmation_text')} /> */}
      {room && <ConfirmationContent room={room} />}
      {subscription && <SubscriptionConfirmation products={productsItems} order={order} subscription={subscription} offer={offer} />}
      <FormButtons>
        <Button classType="cancel" className={classes.backButton} to="/">{t('portal.offers.back_home')}</Button>
        <Button href="https://support.wifirst.net/support/home">{t('ran_activation_confirmation.faq_button')}</Button>
      </FormButtons>
    </Fragment>
  )
}

export default compose(
  withTheme,
  withTranslation(),
)(OfferConfirmation)
